// Keep on sync with Provision.VerticalMarket.sql
export enum VerticalMarket {
	AccountsReceivableManagement = 1,
	PropertyManagement = 2,
	FinanceCreditUnion = 3,
	FinanceAuto = 4,
	Pharmacy = 5,
	HealthCare = 6,
	B2B = 7,
	Energy = 8,
}
